import { render, staticRenderFns } from "./ExtShops.vue?vue&type=template&id=1c5b0036&scoped=true"
import script from "./ExtShops.vue?vue&type=script&lang=ts"
export * from "./ExtShops.vue?vue&type=script&lang=ts"
import style0 from "./ExtShops.vue?vue&type=style&index=0&id=1c5b0036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5b0036",
  null
  
)

export default component.exports